import React, { useEffect, useState } from 'react';
import { GET_PASSENGERV1_URI, GET_SCHEPASSENGER_LIST } from '../constant';
import { Circles } from 'react-loader-spinner';
import axios from 'axios';
import PassengerTable from '../components/tables/PassengerTable';
import { currentDateFormat } from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import SaveButton from '../components/buttons/SaveButton';
import SearchComponent from '../components/SearchComponent';


const PassengerList = () => {
  const [passengerDetails, setPassengerDetails] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [visitFrequency, setVisitFrequency] = useState("0");
  const [PMINumber, setPMINumber] = useState('');
  const dispatch = useDispatch();
  const [isReload, setIsReload] = useState(false);
  const [passengerList, setPassengerList] = useState([]);
  const loading = useSelector((state) => state.loader.loading);
  const [selectedPassenger, setSelectedPassenger] = useState(null);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    recordsPerPage: 10,
  });

  const PRIMARY_COLOR = '#F4A442';
  const SECONDARY_COLOR = '#2D5A50';

  const handleKeyDown = (e) => {
    const value = e.target.value;
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];
    const isNumberKey = /^[0-9]$/.test(e.key);
    if ((!isNumberKey && !allowedKeys.includes(e.key)) ||
      (e.target.value.length >= 8 && !allowedKeys.includes(e.key))
    ) {
      e.preventDefault();
    }
  };

  const fetchData = async (page = 1) => {
    dispatch(setLoading(true));
    try {
      const params = {
        passenger_id: selectedPassenger?.value?.user_id || '',
        pmi_number: PMINumber || '',
        visit_frequency: visitFrequency || '0',
        page,
        limit: pagination.recordsPerPage || 10,
      };
      const response = await axios.get(GET_PASSENGERV1_URI, { params });
      if (response?.data?.status === "200") {
        const data = response.data.data || [];
        const p = response.data.pagination || {};
        setPassengerDetails(data);
        setPagination({
          currentPage: p.currentPage ?? page,
          totalPages: Math.max(1, p.totalPages ?? 1),
          totalRecords: p.totalRecords ?? data.length,
          recordsPerPage: p.recordsPerPage ?? (pagination.recordsPerPage || 10),
        });
      } else {
        setPassengerDetails([]);
        setPagination((prev) => ({ ...prev, totalPages: 1, totalRecords: 0 }));
      }
    } catch (error) {
      console.error('Error fetching passengers:', error);
      setPassengerDetails([]);
    } finally {
      dispatch(setLoading(false));
    }
  };


  useEffect(() => {
    fetchData(currentPage);
    const userData = async () => {
      const response_2 = await axios.get(GET_SCHEPASSENGER_LIST);
      setPassengerList(response_2.data);
    }
    userData();
  }, []);

  useEffect(() => {
    fetchData(currentPage);
  }, [isReload, dispatch, currentPage]);

  //   const handleFilterChange =useMemo( (event) => {
  //     const filtered = passengerDetails.filter(passenger => {
  //      const matchesVisitFrequency =   visitFrequency === "0" || 
  //                                     (visitFrequency === "1" && passenger.visit_frequency === 1) || 
  //                                     (visitFrequency === "2" && passenger.visit_frequency === 2);
  //       const matchesPassengerName = passengerName === '' || (passenger.passenger_name?.replace(/\s+/g, ' ').trim().toLowerCase() || '').includes(passengerName.toLowerCase());
  //       const matchesPMINumber     = PMINumber === '' || passenger.pass_pmi_no.includes(PMINumber);
  //       return matchesVisitFrequency && matchesPassengerName && matchesPMINumber;
  //   });
  //   setFilteredPassengerDetails(filtered);
  // },[visitFrequency,passengerName,PMINumber]);

  const passengerListWithFullName = passengerList.map(passenger => {
    const fullName = `${passenger.first_name || ''} ${passenger.middle_name || ''} ${passenger.last_name || ''}`
      .replace(/\s+/g, ' ') // Remove extra spaces
      .trim()
      .toLowerCase();

    return {
      ...passenger,
      full_name: fullName
    };
  });
  const handleSearch = async () => {
    setIsSearchLoading(true);
    try {
      // Reset to first page when searching
      setCurrentPage(1);
      await fetchData(1);
    } finally {
      setIsSearchLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const { currentPage: pg, totalPages, totalRecords, recordsPerPage } = pagination;
  const startIndex = (pg - 1) * recordsPerPage;
  const endIndex = Math.min(startIndex + (passengerDetails?.length || 0), totalRecords);

  const getPageNumbers = () => {
    if (totalPages <= 4) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    return [1, 2, 3, 'ellipsis', totalPages];
  };

  const pageNumbers = getPageNumbers();

  return (
    <><section>
      <div className='d-flex justify-content-between form-container'>
        <div>
          <h2 className="fs-5 font-weight-600">Passenger List  </h2>
        </div>
        <div>
          <span >{currentDateFormat(currentDate)}</span>
        </div>
      </div>
    </section>
      <section className='filter-section'>
        <div className='d-flex justify-content-between filter-container'
          style={{ background: 'rgb(205 228 218 / 29%)' }}
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <div className='schedule-filter'>
              <div className="me-2">
                <label>Status</label>
                <select
                  className="form-select"
                  name="visit_frequency"
                  onChange={(e) => setVisitFrequency(e.target.value)}
                  value={visitFrequency}
                >
                  <option value="0">Any</option>
                  <option value="1">Recurring</option>
                  <option value="2">One Time</option>
                </select>
              </div>
              {/* <div className="me-2">
              <label style={{display:"block"}}>Passenger</label>
              <input type="text" 
              name="passenger_name" 
              className="form-control"
              autoComplete='off'
              value={passengerName} 
              style={{minWidth: '180px',maxWidth: '100%'}}
              placeholder='Search Passenger'
              onChange={(e)=>  setPassengerName(e.target.value)}
                />
              
            </div> */}
              <div className="me-2">
                {/* <label style={{display:"block"}}>Passenger</label> */}
                <SearchComponent
                  data={passengerListWithFullName}
                  searchFields={["full_name"]}
                  placeholder="Search Passenger"
                  label="Passenger"
                  onSelect={(selectedPassenger) => {
                    setSelectedPassenger(selectedPassenger);
                  }}
                />

              </div>
              <div className="me-2">
                <label style={{ display: "block" }}>PMI Number</label>
                <input type="number"
                  name="pmi_number"
                  autoComplete='off'
                  className="form-control"
                  placeholder='Search PMI'
                  value={PMINumber}
                  onChange={(e) => setPMINumber(e.target.value)}
                  onKeyDown={handleKeyDown}
                />

              </div>
              <div>
                <div>
                <button
                  className="btn btn-primary rounded-1"
                  type="button"
                  style={{
                    background: "#31876f",
                    border: "unset",
                    height: "38px",
                    color: "#fff",
                    padding: "7px",
                  }}
                  onClick={handleSearch}
                  disabled={isSearchLoading}
                >
                  {isSearchLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Searching...
                    </>
                  ) : (
                    "Search"
                  )}
                </button>
                </div>
              </div>
            </div>

          </form>
        </div>
      </section>
      <section>
        <div>
          <PassengerTable tableData={passengerDetails} setIsReload={setIsReload} />
        </div>
        {totalPages > 1 && (
          <div
            className="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3 px-4 py-3 mt-0"
            style={{ backgroundColor: 'rgba(248, 249, 250, 0.8)', border: '1px solid #e9ecef', borderTop: 'none', borderRadius: '0 0 0.25rem 0.25rem' }}
          >
            <p className="text-sm text-muted mb-0">
              Showing <span style={{ color: SECONDARY_COLOR, fontWeight: 700 }}>{passengerDetails?.length ? startIndex + 1 : 0}-{endIndex}</span> of <span style={{ color: SECONDARY_COLOR, fontWeight: 700 }}>{totalRecords}</span> results
            </p>
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-link p-2 text-secondary border-0 shadow-none"
                style={{ opacity: pg === 1 ? 0.35 : 1 }}
                disabled={pg === 1}
                onClick={() => handlePageChange(1)}
                title="First page"
                aria-label="First page"
              >
                <i className="pi pi-angle-double-left" />
              </button>
              <button
                type="button"
                className="btn btn-link p-2 text-secondary border-0 shadow-none me-1"
                style={{ opacity: pg === 1 ? 0.35 : 1 }}
                disabled={pg === 1}
                onClick={() => handlePageChange(pg - 1)}
                title="Previous page"
                aria-label="Previous page"
              >
                <i className="pi pi-angle-left" />
              </button>
              <div className="d-flex align-items-center gap-1">
                {pageNumbers.map((p, i) =>
                  p === 'ellipsis' ? (
                    <span key={`ellipsis-${i}`} className="px-2 text-muted">...</span>
                  ) : (
                    <button
                      key={p}
                      type="button"
                      className="btn btn-sm fw-semibold rounded"
                      style={{
                        minWidth: 32,
                        height: 32,
                        backgroundColor: p === pg ? PRIMARY_COLOR : 'transparent',
                        color: p === pg ? '#fff' : '#495057',
                        border: 'none',
                        boxShadow: p === pg ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
                      }}
                      onClick={() => handlePageChange(p)}
                      aria-label={`Page ${p}`}
                      aria-current={p === pg ? 'page' : undefined}
                    >
                      {p}
                    </button>
                  )
                )}
              </div>
              <button
                type="button"
                className="btn btn-link p-2 text-secondary border-0 shadow-none ms-1"
                style={{ opacity: pg === totalPages ? 0.35 : 1 }}
                disabled={pg === totalPages}
                onClick={() => handlePageChange(pg + 1)}
                title="Next page"
                aria-label="Next page"
              >
                <i className="pi pi-angle-right" />
              </button>
              <button
                type="button"
                className="btn btn-link p-2 text-secondary border-0 shadow-none"
                style={{ opacity: pg === totalPages ? 0.35 : 1 }}
                disabled={pg === totalPages}
                onClick={() => handlePageChange(totalPages)}
                title="Last page"
                aria-label="Last page"
              >
                <i className="pi pi-angle-double-right" />
              </button>
            </div>
          </div>
        )}
      </section>
      {loading && <Loader />}
    </>
  );
}
export default PassengerList;